import { Resource } from '../types';

/** Alphabetical by display name (case-insensitive), for dropdowns and roster lists. */
export function sortResourcesByName(resources: Resource[]): Resource[] {
  return [...resources].sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
  );
}
